<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
  >
    <v-card>
      <v-card-title class="headline">Confirmar Exclusão</v-card-title>
      <v-card-text>
        Tem certeza que deseja excluir a categoria "{{ category?.name }}"?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cancelDelete">Cancelar</v-btn>
        <v-btn
          color="error"
          @click="confirmDelete"
          :loading="deleting"
        >
          Excluir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "CategoryDeleteDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    platform: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      deleting: false
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    cancelDelete() {
      this.dialog = false;
    },

    async confirmDelete() {
      if (!this.category) return;
      
      try {
        this.deleting = true;
        await platformService.deleteCategory(this.platform.id, this.category.id);
        
        this.dialog = false;
        this.$emit('deleted');
        
      } catch (error) {
        console.error("Erro ao excluir categoria:", error);
      } finally {
        this.deleting = false;
      }
    }
  }
};
</script> 